import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <polygon points="6.3,25 20.5,12.5 6.3,0 3,3 13.8,12.5 3,22 " />
    </g>
  </svg>
);
